export default {
  title: 'Bestelgegevens',
  order_again: 'Opnieuw bestellen',
};
